import { createTheme } from '@mui/material/styles'
import components from './components'
import { themeOptions } from './palette'

const muiTheme = createTheme({
  ...themeOptions,
  components,
})

export default muiTheme
